import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import LanguageContext from '../contexts/LanguageContext';
import { getTranslation } from '../services/languageService';
import './Footer.scss';

const Footer = () => {
  const { language } = useContext(LanguageContext);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">{getTranslation('footer.companyName', language)}</h3>
            <p className="footer-description">
              {getTranslation('home.hero.subtitle', language)}
            </p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-subtitle">{getTranslation('footer.quickLinks', language)}</h4>
            <ul className="footer-links">
              <li><Link to="/">{getTranslation('navigation.home', language)}</Link></li>
              <li><Link to="/about">{getTranslation('navigation.about', language)}</Link></li>
              <li><Link to="/services">{getTranslation('navigation.services', language)}</Link></li>
              <li><Link to="/portfolio">{getTranslation('navigation.portfolio', language)}</Link></li>
              <li><Link to="/contact">{getTranslation('navigation.contact', language)}</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-subtitle">{getTranslation('footer.contactInfo', language)}</h4>
            <ul className="footer-contact">
              <li>{getTranslation('contact.info.address', language)}: 161, Jalan Tunku Putra, Kulim</li>
              <li>{getTranslation('contact.info.phone', language)}: +60 124823757</li>
              <li>{getTranslation('contact.info.email', language)}: appliedintelli.my@gmail.com</li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 {getTranslation('footer.companyName', language)}. {getTranslation('footer.rights', language)}.</p>
          <p className="footer-registration">{getTranslation('footer.registration', language)}</p>
          <div className="footer-legal">
            <Link to="/privacy">{getTranslation('navigation.privacy', language)}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
